import {Requests,  Signals} from "@/Imports";
import Facade from "@/Facade";

export default class BackendManager {

  constructor () {
    // Game listenter
    Signals.gameMessage.add(this.onGameMessage, this)

    // Backend listener
    Signals.backendMessage.add(this.onBackendMessage, this)

    this.requests = new Requests()
  }

  onGameMessage(message) {
    ///BonusGameContainer.showTime("ON_GAME_MESSAGE "+message)
    switch (message) {
      case 'init':
        console.log('onGameMessage init', this.requests.URLParser.data);
        this.requests.getInit(this.requests.URLParser.data)
        break

      case 'spin':
        console.log('onGameMessage spin', Facade.model.lineBet);
        this.requests.getSpin({amount: Facade.model.fixedCoinsBet, coinValue: Facade.model.coinValue})
        break

      case 'buy_freebet':
        console.log('onGameMessage buy_freebet', Facade.model.buyFreebetChoose);
        this.requests.getBuyFreespin({ buyFreebet: Facade.model.buyFreebetChoose, coinValue: Facade.model.coinValue })
        break

      case 'terminate':
        this.requests.getTerminate()
        break

      case 'balance':
        this.requests.getBalance()
        break
    }
  }

  onBackendMessage(message) {
    // BonusGameContainer.showTime("onBackendessage")
    switch (message.action) {
      case 'init':
        console.log('onBackendessage init',  message);
        Signals.initGame.dispatch(message)
        break

      case 'spin':
        console.log('onBackendessage spin',  message);
        Signals.spinResponse.dispatch(message)
        break

      case 'buy_freebet':
        console.log('onBackendessage buy_freebet',  message);
        Signals.buyFreespinResponse.dispatch(message)
        break

      case 'balance':
        console.log('onBackendessage balance',  message);
        Signals.balanceResponse.dispatch(message)
        break

    }
  }

}